<template>
  <span>
    <i v-if="name === 'table'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-layout-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <rect x="4" y="4" width="6" height="5" rx="2" />
        <rect x="4" y="13" width="6" height="7" rx="2" />
        <rect x="14" y="4" width="6" height="7" rx="2" />
        <rect x="14" y="15" width="6" height="5" rx="2" />
      </svg>
    </i>
    <i v-if="name === 'new'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-shopping-cart-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <circle cx="6" cy="19" r="2" />
        <circle cx="17" cy="19" r="2" />
        <path d="M17 17h-11v-14h-2" />
        <path d="M6 5l6.005 .429m7.138 6.573l-.143 .998h-13" />
        <path d="M15 6h6m-3 -3v6" />
      </svg>
    </i>
    <i v-if="name === 'comanda'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-square-number-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
         <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
         <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
         <path d="M10 10l2 -2v8"></path>
      </svg>
    </i>
    <i v-if="name === 'fast'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bolt" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
         <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
         <path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11"></path>
      </svg>
    </i>
    <i v-if="name === 'delivery'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-moped" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <circle cx="18" cy="17" r="2" />
        <path d="M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1" />
        <line x1="6" y1="9" x2="9" y2="9" />
      </svg>
    </i>
    <i v-if="name === 'search'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-list-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <circle cx="15" cy="15" r="4" />
        <path d="M18.5 18.5l2.5 2.5" />
        <path d="M4 6h16" />
        <path d="M4 12h4" />
        <path d="M4 18h4" />
      </svg>
    </i>
    <i v-if="name === 'device'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-device-desktop" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
         <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
         <path d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z"></path>
         <path d="M7 20h10"></path>
         <path d="M9 16v4"></path>
         <path d="M15 16v4"></path>
      </svg>
    </i>
    <i v-if="name === 'relatorio'">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chart-bar" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <rect x="3" y="12" width="6" height="8" rx="1" />
        <rect x="9" y="8" width="6" height="12" rx="1" />
        <rect x="15" y="4" width="6" height="16" rx="1" />
        <line x1="4" y1="20" x2="18" y2="20" />
      </svg>
    </i>
  </span>
</template>
<script>
  export default {
    name: "icon-sys",
    props: ['name','size'],
    data() {
      return {
        swiper: '',
      }
    }
  }
</script>
<style scoped>
</style>
